module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_2_02-b4820ecc9d57f3c92b9b6711cb040a21.jpg";